import { Pipe, PipeTransform } from '@angular/core';
import { nodesToKmph } from '@mri/functions';

@Pipe({
  name: 'renderSpeed',
  standalone: true
})
export class RenderSpeedPipe implements PipeTransform {

  transform(value: number, unit: string = 'km'): string {
    if(unit == 'km') return nodesToKmph(value).toFixed(1) + ' Km/h';
    return value.toFixed(1) + ' Nudos';
  }

}
